import React, {useEffect, useRef, useState} from "react";
import Select from "./common/Select";
import Bitrix24 from "../server/bitrix24";
import Helper from "../common/helper";
import {ListGroup, Modal} from "react-bootstrap";
import TreeSection from "./TreeSection";
import CardProduct from "./CardProduct";
import Server from "../server/server";

const AddProduct = ({
                        deal = {},
                        setDeal,
                        optionsPodrazdelenie = [],
                        optionsPrice = [],
                        dealProduct = [],
                        setDealProduct,
                        products1C = []
                    }) => {

    const bitrixConnect = new Bitrix24()
    const server = new Server()

    const [availability, setAvailability] = useState(false);
    const [searchAll, setSearchAll] = useState(true);
    const [search, setSearch] = useState('');

    const [loading, setLoading] = useState(false);

    const [sectionCatalog, setSectionCatalog] = useState([]);
    const [productCatalog, setProductCatalog] = useState([]);
    const [productCatalogSearch, setProductCatalogSearch] = useState([]);
    const [productAnalog, setProductAnalog] = useState([]);

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showDoubleProduct, setShowDoubleProduct] = useState(false);
    const [count, setCount] = useState(1);

    const refCount = useRef(null)

    useEffect(() => {
        bitrixConnect.loadCatalogSection().then(result => {
            setSectionCatalog(Helper.buildTree(result, null, 'SECTION_ID', 'ID'))
        })
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {

            if (!deal.UF_CRM_DEAL_PODRAZDELENIE || !deal.UF_CRM_DEAL_PRICE) {
                alert('Для выбора товара необходимо выбрать склад и цену')
                setProductCatalogSearch([])
                return;
            }

            if (searchAll) {
                if (search) {
                    setLoading(true)
                    bitrixConnect.loadCatalogProductSearch(search).then(result => {
                        setProductCatalogSearch(result.sort((a, b) => {
                            return a.NAME.localeCompare(b.NAME)
                        }).filter(item => {
                            const product = products1C.find(product => product.XML_ID === item.XML_ID)

                            let isSearch = true

                            if (availability) {
                                isSearch = isSearch && product?.QUANTITY > 0
                            }

                            return isSearch
                        }).slice(0, 100))

                        setLoading(false)
                    })
                } else {
                    setProductCatalogSearch([])
                }
            } else {
                setProductCatalogSearch(productCatalog.filter(item => {
                    const product = products1C.find(product => product.XML_ID === item.XML_ID)

                    let isSearch = true

                    if (search) {
                        isSearch = isSearch && item.NAME.toLowerCase().includes(search.toLowerCase())
                            || product?.CODE.toLowerCase().includes(search.toLowerCase())
                    }
                    if (availability) {
                        isSearch = isSearch && product?.QUANTITY > 0
                    }

                    return isSearch
                }).slice(0, 100))
            }
        }, 1000)

        return () => clearTimeout(timer)
    }, [search, productCatalog, searchAll, availability])

    const onLoadProduct = (sectionId) => {
        bitrixConnect.loadCatalogProduct(sectionId).then(result => {
            setProductCatalog(result)
        })
    }

    const loadProductAnalog = (productXML) => {
        server.loadAnalog(productXML).then(result => {
            if (result.PRODUCTS.PRODUCT?.length > 0) {
                bitrixConnect.loadProduct(result.PRODUCTS.PRODUCT.map(item => item.XML_ID)).then(result => {
                    setProductAnalog(result)
                })
            } else {
                setProductAnalog([])
            }
        })
    }

    const addDealProduct = (isAdd) => {
        const product = products1C.find(item => item.XML_ID === selectedProduct.XML_ID)

        // if (product?.QUANTITY <= 0) {
        //     alert("Нельзя добавить товар с нулевым остатком")
        //     setSelectedProduct(null)
        //     setCount(1)
        //
        //     return
        // }

        if (isAdd === undefined && dealProduct?.filter(product => parseInt(product.PRODUCT_ID) === parseInt(selectedProduct?.ID))?.length > 0) {
            setShowDoubleProduct(true)
            return
        }

        if (isAdd === undefined) {
            isAdd = true
        }

        let newDealProduct = dealProduct.map(product => {
            if (!isAdd && parseInt(product.PRODUCT_ID) === parseInt(selectedProduct.ID)) {
                product.COUNT = parseFloat(product.COUNT) + parseFloat(count);
                isAdd = false;
            }

            return product
        })
        if (isAdd) {
            newDealProduct.push({
                PRODUCT_ID: parseInt(selectedProduct.ID),
                NAME: selectedProduct.NAME,
                COUNT: count,
                CODE: selectedProduct?.PROPERTY_174 ?? product.CODE,
                PRICE: parseInt(product?.PRICE ?? selectedProduct.PRICE)
            })
        }

        setDealProduct(newDealProduct)
        setSelectedProduct(null)
        setShowDoubleProduct(false)
        setCount(1)
    }

    // const productCatalogSearch = productCatalog.filter(item => {
    //     const product = products1C.find(product => product.XML_ID === item.XML_ID)
    //
    //     let isSearch = true
    //
    //     if (search) {
    //         isSearch = isSearch && item.NAME.toLowerCase().includes(search.toLowerCase())
    //         || product?.CODE.toLowerCase().includes(search.toLowerCase())
    //     }
    //     if (availability) {
    //         isSearch = isSearch && product?.QUANTITY > 0
    //     }
    //
    //     return isSearch
    // }).slice(0, 100)

    return (
        <>
            <div className="row align-items-end">
                <div className="col-3">
                    <Select name="UF_CRM_DEAL_PODRAZDELENIE"
                            label="Склад"
                            value={deal.UF_CRM_DEAL_PODRAZDELENIE}
                            options={optionsPodrazdelenie}
                            onChange={(val) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_PODRAZDELENIE: val}))}/>
                </div>
                <div className="col-3">
                    <Select name="UF_CRM_DEAL_PRICE"
                            label="Тип цен"
                            value={deal.UF_CRM_DEAL_PRICE}
                            options={optionsPrice}
                            onChange={(val) => setDeal(prevState => ({...prevState, UF_CRM_DEAL_PRICE: val}))}/>
                </div>
                <div className="col-2">
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input"
                               checked={availability}
                               onChange={() => setAvailability(!availability)}/>
                        <label className="form-check-label">Только в наличии</label>
                    </div>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input"
                               checked={searchAll}
                               onChange={() => setSearchAll(!searchAll)}/>
                        <label className="form-check-label">Поиск по всем</label>
                    </div>
                </div>
                <div className="col-4">
                    <label className="form-label">Поиск</label>
                    <input id="search" type="text" className="form-control"
                           value={search}
                           onChange={(event) => setSearch(event.target.value)}/>
                </div>
            </div>
            <div className="row mt-3" style={{height: "300px"}}>
                {!searchAll && (
                    <div className="col-5 overflow-scroll" style={{height: "300px"}}>
                        <TreeSection sections={sectionCatalog} onLoadProduct={onLoadProduct}/>
                    </div>
                )}
                <div className="col overflow-scroll" style={{height: "300px"}}>
                    <table className={"table table-hover" + (loading ? ' preloader' : '')}>
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Код</th>
                            <th scope="col">Наименование</th>
                            <th scope="col">Коммент</th>
                            <th scope="col">Остаток</th>
                            <th scope="col">В пути</th>
                            <th scope="col">Резерв</th>
                            <th scope="col">Цена</th>
                            <th scope="col">Единица</th>
                        </tr>
                        </thead>
                        <tbody id="products">
                        {productCatalogSearch.map((item, index) => {
                            const product = products1C.find(product => product.XML_ID === item.XML_ID)

                            return (
                                <tr key={index}
                                    onClick={() => loadProductAnalog(item.XML_ID)}
                                    onDoubleClick={() => setSelectedProduct(item)}
                                >
                                    <th scope="row">{index + 1}</th>
                                    <td>{product?.CODE}</td>
                                    <td>{item.NAME}</td>
                                    <td>{product?.COMMENT}</td>
                                    <td>{product?.QUANTITY ? new Intl.NumberFormat("ru", {style: "decimal"}).format(product.QUANTITY) : 0}</td>
                                    <td>{product?.ONWAY}</td>
                                    <td>{product?.INRESERVE}</td>
                                    <td>{product?.PRICE ?? item.PRICE}</td>
                                    <td></td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col">
                    <h4>Аналоги</h4>
                </div>
            </div>
            <div className="row overflow-scroll" style={{height: "200px"}}>
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Код</th>
                        <th scope="col">Наименование</th>
                        <th scope="col">Коммент</th>
                        <th scope="col">Остаток</th>
                        <th scope="col">Цена</th>
                        <th scope="col">Единица</th>
                    </tr>
                    </thead>
                    <tbody id="analogs">
                    {productAnalog.map((item, index) => {
                        const product = products1C.find(product => product.XML_ID === item.XML_ID)

                        return (
                            <tr key={index}
                                onDoubleClick={() => setSelectedProduct(item)}
                            >
                                <th scope="row">{index + 1}</th>
                                <td>{product?.CODE}</td>
                                <td>{item.NAME}</td>
                                <td>{product?.COMMENT}</td>
                                <td>{product?.QUANTITY ? new Intl.NumberFormat("ru", {style: "decimal"}).format(product.QUANTITY) : 0}</td>
                                <td>{product?.PRICE ?? item.PRICE}</td>
                                <td></td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
            <CardProduct dealProduct={dealProduct} setDealProduct={setDealProduct} products1C={products1C} className={"overflow-scroll mt-3"} style={{height: "300px"}}/>
            <Modal show={!!selectedProduct && !showDoubleProduct} onHide={() => setSelectedProduct(null)} className="modal-z-index-top" backdropClassName={"modal-z-index-top"} onShow={() => {
                refCount?.current?.focus()
            }}>
                <Modal.Header closeButton>
                    <Modal.Title>Количество</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form action="" onSubmit={(event) => {
                        event.preventDefault()
                        addDealProduct()
                    }}>
                        <input type="number" className="form-control form-control-sm"
                               ref={refCount}
                               value={count}
                               onChange={(event) => setCount(event.target.value)}
                               />
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => addDealProduct()}>Добавить</button>
                </Modal.Footer>
            </Modal>
            <Modal show={!!selectedProduct && showDoubleProduct} onHide={() => {
                setSelectedProduct(null)
                setShowDoubleProduct(false)
            }} className="modal-z-index-top" backdropClassName={"modal-z-index-top"}>
                <Modal.Header closeButton>
                    <Modal.Title>Товар уже выбран. Добавить к выбранному?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <button type="button" className="btn btn-secondary" style={{marginRight: '10px'}}
                            onClick={() => addDealProduct(false)}>Да</button>
                    <button type="button" className="btn btn-secondary" onClick={() => addDealProduct(true)}>Нет</button>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddProduct